import { render, staticRenderFns } from "./TrainingsList.vue?vue&type=template&id=172cd921&scoped=true&"
import script from "./TrainingsList.vue?vue&type=script&lang=js&"
export * from "./TrainingsList.vue?vue&type=script&lang=js&"
import style0 from "./TrainingsList.vue?vue&type=style&index=0&id=172cd921&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172cd921",
  null
  
)

export default component.exports